import React from 'react';
import ReactDOM from 'react-dom';
import './main.css';
import LetsPlayBingo from './LetsPlayBingo';
ReactDOM.render(<LetsPlayBingo />, document.getElementById('root'));